import { render, staticRenderFns } from "./coin.form.vue?vue&type=template&id=4268a4fd&lang=pug"
import script from "./coin.form.vue?vue&type=script&lang=js"
export * from "./coin.form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports